/* tslint:disable */
/* eslint-disable */
/**
 * Notes API
 * API for managing notes with tags, mentions and attachments
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Minimal information about a person
 * @export
 * @interface PersonMinimalDto
 */
export interface PersonMinimalDto {
    /**
     * Unique identifier of the person
     * @type {string}
     * @memberof PersonMinimalDto
     */
    id?: string;
    /**
     * Full name of the person
     * @type {string}
     * @memberof PersonMinimalDto
     */
    fullName?: string;
    /**
     * Initials of the person (e.g., JD for John Doe)
     * @type {string}
     * @memberof PersonMinimalDto
     */
    initials?: string;
}

/**
 * Check if a given object implements the PersonMinimalDto interface.
 */
export function instanceOfPersonMinimalDto(value: object): value is PersonMinimalDto {
    return true;
}

export function PersonMinimalDtoFromJSON(json: any): PersonMinimalDto {
    return PersonMinimalDtoFromJSONTyped(json, false);
}

export function PersonMinimalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonMinimalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
        'initials': json['initials'] == null ? undefined : json['initials'],
    };
}

export function PersonMinimalDtoToJSON(json: any): PersonMinimalDto {
    return PersonMinimalDtoToJSONTyped(json, false);
}

export function PersonMinimalDtoToJSONTyped(value?: PersonMinimalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fullName': value['fullName'],
        'initials': value['initials'],
    };
}

